import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";
import {ActivatedRoute} from "@angular/router";
import {Session} from "../../services/session.service";

@Component({
  selector: 'app-doc',
  templateUrl: './doc.component.html',
  styleUrls: ['./doc.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DocComponent implements OnInit {

  content: string = "";

  constructor(private activatedRoute: ActivatedRoute) {

  }

  ngOnInit() {
    Session.loggedIn = true;
    Session.loggedInObserver.next(true);
    Session.headerObserver.next(false);

    this.activatedRoute.params.subscribe(param => {
      let ref: string = param["ref"];

      let rawFile: XMLHttpRequest = new XMLHttpRequest();
      rawFile.open("GET", `../assets/docs/${ref}.txt`, false);
      rawFile.onreadystatechange = (ev) => {
        if (rawFile.readyState == 4) {
          if(rawFile.status == 200 || rawFile.status == 0){
            this.content = rawFile.responseText;
          }
        }
      };
      rawFile.send(null);
    });
  }
}



// WEBPACK FOOTER //
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/pages/doc/doc.component.ts